import PipelineScrollerPanel from './pipeline-scroller-panel';
export default function PipelineScroller() {
  return (
    <div className="h-100" id="pipeline-scroller-viewport">
      {/* keep file in case of extra components */}
      <PipelineScrollerPanel />
    </div>
  );
}
//d-flex flex-column <div className="flex-grow-1 overflow-hidden">
